// ECharts component internationalization content

export default {
  // Chart default configurations
  defaultTitle: "Bar Chart Example",
  defaultSeriesName: "Data Volume",
  unitPrefix: "(Unit: ",
  unitSuffix: ")",

  // Specific unit displays
  unitTenThousandUSDT: "(Unit: 10K USDT)",
  unitCount: "(Unit: Count)",

  // Pie chart related
  monitorAddressRatio: "Monitor Address Ratio",
  ratioSeriesName: "Ratio",

  // Bar chart related
  inflowDataStatistics: "Inflow Data Statistics",
  unitTransactions: "(Unit: Transactions)",
  unitTenThousandUSDTWithBrackets: "(Unit: 10K USDT)",
  totalInflowCount: "Total Inflow Count",
  totalInflowAmount: "Total Inflow Amount",

  // Line chart related
  maliciousAddressTransferTrend: "Malicious Address Transfer Trend",
  unitTenThousandYuan: "(10K Yuan)",
  tenThousand: "10K",
  squarePaymentTransaction: "Square Payment Transaction",
  gamblingTransaction: "Gambling Transaction",

  // Map related
  caseCountLabel: "Case Count:",
  indictmentCountLabel: "Indictment Count:",
};
